module.exports = __webpack_public_path__ + "img/58.e64e3b16.jpg";